document.addEventListener('DOMContentLoaded', function() {
    const radioButtons = document.querySelectorAll('.variation-row > label input[type="radio"]');
    
    let currentSlideIndex = 0;
    let lockTimer = null;

    radioButtons.forEach(function(radio, index) {
        if (radio.checked || radio.dataset.currentChecked === 'true') {
            currentSlideIndex = index;
        }
    });

    radioButtons.forEach(function(radio) {
        const label = radio.closest('label');
        if (!label) return;
        label.classList.remove('active');
        if (radio.checked || radio.dataset.currentChecked === 'true') {
            label.classList.add('active');
        }
    });

    function updateCounter(index) {
        const counterCurrent = document.querySelector('[ref="current"]');
        if (counterCurrent) counterCurrent.textContent = index + 1;
    }

    function updateActiveLabel(radio) {
        document.querySelectorAll('.variation-row > label').forEach(function(label) {
            label.classList.remove('active');
        });
        const currentLabel = radio.closest('label');
        if (currentLabel) currentLabel.classList.add('active');
    }

    function swapMainImage(imageSrc) {
        if (!imageSrc) return;
        const firstSlide = document.querySelector('slideshow-slide[ref="slides[]"]');
        if (!firstSlide) return;
        const img = firstSlide.querySelector('img.product-media__image');
        
        if (img) {
            img.src = imageSrc;
            img.srcset = imageSrc;
        }
    }

    radioButtons.forEach(function(radio, index) {
        radio.addEventListener('click', function() {
            const targetIndex = index;
            const imageSrc = this.dataset.imageSrc;

            swapMainImage(imageSrc);
            updateActiveLabel(this);
            updateCounter(targetIndex);
            currentSlideIndex = targetIndex;

            clearTimeout(lockTimer);
            lockTimer = setTimeout(function() {
                updateCounter(targetIndex);
            }, 800);
        });
    });

    const prevBtn = document.querySelector('slideshow-arrows .slideshow-control--previous');
    const nextBtn = document.querySelector('slideshow-arrows .slideshow-control--next');
    const totalSlides = radioButtons.length;

    if (prevBtn) {
        prevBtn.addEventListener('click', function() {
            if (currentSlideIndex > 0) currentSlideIndex--;
            else currentSlideIndex = totalSlides - 1;
        });
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', function() {
            if (currentSlideIndex < totalSlides - 1) currentSlideIndex++;
            else currentSlideIndex = 0;
        });
    }

    updateCounter(currentSlideIndex);
});